module.exports = __webpack_public_path__ + "img/mz.ef4657da.svg";